import React, { useRef } from "react";
import css from '../style.scss';
import LeaveMessagePopup from "../modals/LeaveMessage";
import ImageCropModal from "components/AvatarEditorModal";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const UploadProfilePicture = ({label, filed, setFieldValue, setImageUrl , leaveMessagePopup, openImageCropModal, closeImageCropModal }) => {
  const fileInputRef = useRef(null);

  // Allowed MIME types
  const allowedFormats = [
    "image/jpeg",
    "image/png",
    "image/webp"
  ];

  const handleClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!allowedFormats.includes(file.type)) {
        leaveMessagePopup({
          title: "Invalid file format",
          message: "Please upload JPEG, PNG, or WebP.",
          cancelLable: null,
          yesLable: 'Ok',
          yesRedirect: () => null,
        });
        event.target.value = ""; // Reset input to prevent uploading the invalid file
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        openImageCropModal({
          image: reader.result, // Pass the full Data URL for preview
          onSubmit: (croppedImage) => {
            if (croppedImage) {
              const croppedBase64 = croppedImage.split(',')[1];
              // Update the marketingProfilePicture field in Formik with Base64
              setFieldValue(filed, croppedBase64, null);
              // Set the image URL for previewing the uploaded image
              setImageUrl(croppedBase64);
            }
          },
          closePopup: () => {       
            closeImageCropModal(); }
        })
      };

      reader.readAsDataURL(file); // Read the file as a Base64 string
      event.target.value = ""; // Reset input to allow selecting the same file again
    }
  };

  return (
    <div>
      <a href="#" className={css.clsAddTxt} onClick={handleClick}>
        {label || 'Add Photo'}
      </a>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/jpeg, image/png, image/webp" // Prevents selecting unsupported files in most browsers
        onChange={handleFileChange}
      />
    </div>
  );
};

export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open,
  openImageCropModal: ImageCropModal.open,
  closeImageCropModal: ImageCropModal.close,
})(UploadProfilePicture));